module.exports = __webpack_public_path__ + "img/imgWeb4.ef5365b8.png";